import React from "react";
import Header from './Header';
import Footer from './Footer';

function ContactUs() {
    return (
        <div className="app-container">
            <Header />

            <main className="main-content">
                <section className="section">
                    <h2>Contact Us</h2>
                    <form className="contact-form">
                        <label>
                            Name:
                            <input type="text" name="name" required />
                        </label>
                        <label>
                            Email:
                            <input type="email" name="email" required />
                        </label>
                        <label>
                            Message:
                            <textarea name="message" required></textarea>
                        </label>
                        <button type="submit">Send</button>
                    </form>
                </section>
            </main>

            <Footer />
        </div>
    );
}

export default ContactUs;
